export default {
    to: "/dashboard/waas/nearest-agents",
    order: 3,
    icon: "mdi-find-replace",
    title: "Find Nearest Agents",
    disabled: false,
    value: 0,
}
